import { render, staticRenderFns } from "./AdminManualQuestionnaireAnswer.vue?vue&type=template&id=08f5e458&scoped=true&"
import script from "./AdminManualQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
export * from "./AdminManualQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./AdminManualQuestionnaireAnswer.vue?vue&type=style&index=0&id=08f5e458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5e458",
  null
  
)

export default component.exports